import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { ModeloVehiculoCreateInterface } from "../../interfaces/modelovehiculosinterfaces/ModeloVehiculoCreate.interface";
import { ModelosVehiculoInterface } from "../../interfaces/modelovehiculosinterfaces/ModeloVehiculo.interface";

export async function UpdateModeloVehiculoAction(
    modeloId: string,
    updateData: Partial<ModeloVehiculoCreateInterface>
): Promise<ApiResponse<ModelosVehiculoInterface>> {
    const { data } = await apiClient.patch<ModelosVehiculoInterface>(  
        `gvModeloVehiculos/${modeloId}`,
        updateData
    );
    return {
        status: 200,
        data,
        message: "Modelo de Vehiculo actualizada correctamente",
    };

}